import { useGetBriefDeliverables } from "@entities/brief/lib/hooks/useGetBriefDeliverables";
import { SearchMultiSelectFilter } from "@shared/ui/filters/SearchMultiSelectFilter";

interface PricingDeliverableFilterProps {
  briefId: string;
  confirm: () => void;
  close: () => void;
  selectedValues: string[];
  onApply: (values: string[]) => void;
}

export function PricingDeliverableFilter({
  briefId,
  confirm,
  close,
  selectedValues,
  onApply,
}: PricingDeliverableFilterProps) {
  const {
    deliverables: deliverableOptions,
    isFetching: isFetchingDeliverables,
  } = useGetBriefDeliverables(briefId);

  const deliverableSelectOptions = [
    ...(deliverableOptions || []).map((deliverable) => ({
      label:
        deliverable?.deliverableV2?.name ??
        `Package - ${deliverable.deliverableV2.setNumber || ""}`,
      value: deliverable?.deliverableV2?._id || "",
    })),
    {
      label: "Unassigned",
      value: "",
    },
  ];

  return (
    <SearchMultiSelectFilter
      confirm={confirm}
      close={close}
      options={deliverableSelectOptions}
      selectedValues={selectedValues}
      onApply={onApply}
      loading={isFetchingDeliverables}
      searchPlaceholder="Search deliverables"
    />
  );
}
